import { Injectable } from "@angular/core";
import { FuseMockApiService } from "@fuse/lib/mock-api";
import { cloneDeep } from "lodash-es";

@Injectable({ providedIn: "root" })
export class VenueMockApi {
  private _advancePaymentConfig = {
    advancePaymentEnabled: false,
    advanceAmount: 0,
    bankName: "",
    accountType: "",
    accountNumber: "",
    accountHolderName: "",
    accountIdentification: "",
    instructions: "",
  };

  constructor(private _fuseMockApiService: FuseMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._fuseMockApiService
      .onGet("api/venue/:id/advance-payment-config")
      .reply(() => [200, { data: cloneDeep(this._advancePaymentConfig) }]);

    this._fuseMockApiService
      .onPut("api/venue/update/:id/advance-payment")
      .reply(({ request }) => {
        this._advancePaymentConfig = cloneDeep({
          ...this._advancePaymentConfig,
          ...request.body,
        });

        return [200, { data: cloneDeep(this._advancePaymentConfig) }];
      });

  }
}
